import { FIELD_MASTER } from "../config";
import { get } from "./apiHelper";

export const getFieldMaster = ({ transactionCode }) => 
  get(`${FIELD_MASTER}${transactionCode}`);
